import { type Partner } from "../../constants/partner"
import { type PartnerPluginConfig } from "../types"
import { DartyEmployeeCard } from "./DartyEmployeeCard"

export const dartyPlugins: PartnerPluginConfig<typeof Partner.Darty> = {
    "portal-page-top": DartyEmployeeCard,
    messages: [],
}

dartyPlugins.messages = [...DartyEmployeeCard.messages] as const
